module.exports = __webpack_public_path__ + "img/GB-WhatsApp-APK for-Android2.7dbd914d.webp";